/* eslint-disable import/no-anonymous-default-export */
import { SET_SHOW_SETTINGS_ON_START } from '../actionConstants';

export default (state = true, action) => {
  switch (action.type) {
    case SET_SHOW_SETTINGS_ON_START:
      return action.payload;
    default:
      return state;
  }
};
